import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCustomerContactResponse } from '@/api/agency/customers/get-customer-contact'

export const mockGetCustomerContact = http.get(
  '/my-business/api/agency/v1/customers/:customerId/contacts',
  () => {
    const data: GetCustomerContactResponse = {
      phone: faker.string.numeric(13),
      email: faker.internet.email(),
      departmentCode: 'MAIN',
      address: {
        address: faker.location.street(),
        cityId: faker.number.int(5),
        departmentEnum: 'MAIN',
        description: '',
        number: faker.string.numeric(3),
        zipCode: faker.helpers.arrayElement(['95040420', '95020471']),
        complement: faker.lorem.sentence(),
      },
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
